// Code generated by protoc-gen-ts_proto. DO NOT EDIT.
// versions:
//   protoc-gen-ts_proto  v2.7.5
//   protoc               v3.21.12
// source: common_enum.proto

/* eslint-disable */

export const protobufPackage = "usertracking.v3";

export enum SearchSource {
  search_box = "search_box",
  popular_cities = "popular_cities",
  recommendation_hotels = "recommendation_hotels",
  recent_search = "recent_search",
  history_cards = "history_cards",
  search_results_page = "search_results_page",
  search_expired = "search_expired",
  price_table = "price_table",
  price_alert = "price_alert",
  notify_me = "notify_me",
  UNRECOGNIZED = "UNRECOGNIZED",
}

export function searchSourceFromJSON(object: any): SearchSource {
  switch (object) {
    case 0:
    case "search_box":
      return SearchSource.search_box;
    case 1:
    case "popular_cities":
      return SearchSource.popular_cities;
    case 2:
    case "recommendation_hotels":
      return SearchSource.recommendation_hotels;
    case 3:
    case "recent_search":
      return SearchSource.recent_search;
    case 4:
    case "history_cards":
      return SearchSource.history_cards;
    case 5:
    case "search_results_page":
      return SearchSource.search_results_page;
    case 6:
    case "search_expired":
      return SearchSource.search_expired;
    case 7:
    case "price_table":
      return SearchSource.price_table;
    case 8:
    case "price_alert":
      return SearchSource.price_alert;
    case 9:
    case "notify_me":
      return SearchSource.notify_me;
    case -1:
    case "UNRECOGNIZED":
    default:
      return SearchSource.UNRECOGNIZED;
  }
}

export function searchSourceToJSON(object: SearchSource): string {
  switch (object) {
    case SearchSource.search_box:
      return "search_box";
    case SearchSource.popular_cities:
      return "popular_cities";
    case SearchSource.recommendation_hotels:
      return "recommendation_hotels";
    case SearchSource.recent_search:
      return "recent_search";
    case SearchSource.history_cards:
      return "history_cards";
    case SearchSource.search_results_page:
      return "search_results_page";
    case SearchSource.search_expired:
      return "search_expired";
    case SearchSource.price_table:
      return "price_table";
    case SearchSource.price_alert:
      return "price_alert";
    case SearchSource.notify_me:
      return "notify_me";
    case SearchSource.UNRECOGNIZED:
    default:
      return "UNRECOGNIZED";
  }
}
